import { useState, useCallback, useRef } from 'react';
import { tcgApi } from '../api/client';

export function useTcgPopulate(onComplete) {
  const [populating, setPopulating] = useState(false);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const pollRef = useRef(null);

  const startPopulate = useCallback(async () => {
    setPopulating(true);
    setError(null);
    setStatus(null);
    try {
      const response = await tcgApi.populate();
      const jobId = response.data.job_id;
      setStatus({ status: 'running', sets_done: 0, sets_total: 0, cards_done: 0, cards_total: 0 });

      // Poll for status every 3 seconds
      pollRef.current = setInterval(async () => {
        try {
          const statusRes = await tcgApi.populateStatus(jobId);
          setStatus(statusRes.data);

          if (statusRes.data.status === 'completed' || statusRes.data.status === 'failed') {
            clearInterval(pollRef.current);
            pollRef.current = null;
            setPopulating(false);
            if (statusRes.data.status === 'completed' && onComplete) {
              onComplete();
            }
            if (statusRes.data.status === 'failed') {
              setError(statusRes.data.error_message || 'Population failed');
            }
          }
        } catch (err) {
          clearInterval(pollRef.current);
          pollRef.current = null;
          setPopulating(false);
          setError('Failed to check populate status');
        }
      }, 3000);
    } catch (err) {
      setPopulating(false);
      setError(err.response?.data?.detail || 'Failed to start population');
    }
  }, [onComplete]);

  return {
    populating,
    status,
    error,
    startPopulate,
  };
}
